import { render, staticRenderFns } from "./toggle-text.vue?vue&type=template&id=620e21ff&scoped=true"
import script from "./toggle-text.vue?vue&type=script&lang=js"
export * from "./toggle-text.vue?vue&type=script&lang=js"
import style0 from "./toggle-text.vue?vue&type=style&index=0&id=620e21ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e21ff",
  null
  
)

export default component.exports